import React from 'react';
import { Select, Switch } from '../Layout';
import { /*TitleH3, TitleSpan,*/ gridItemStyle, checkboxStyle } from '../CreateDeviceContent/styles';
import i18n from '../../helpers/i18n';
import { Grid } from '@mui/material';
import { multipleDeviceTypes } from '../../helpers/consts/deviceConstants';
import timeZones from '../../helpers/consts/timezones';
import { Helper, MultipleDeviceDivider } from '../MultipleDevicesContent/styles';
import InfoTooltip from '../InfoTooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';

export default function MultipleDeviceSection({ formik, cnpjs, isLoadingLocationsAndCnpjs }) {
    return (
        <MultipleDeviceDivider>
            <Helper elevation={0}>
                <li>
                    <span style={{ margin: '0px 4px' }}></span>
                    {i18n.t('pages.multipleDevice.batidaOnlineExplanation')}
                </li>
                <li>
                    <span style={{ margin: '0px 4px' }}></span>
                    {i18n.t('pages.multipleDevice.multiExplanation')}
                </li>
            </Helper>

            <Grid style={gridItemStyle} item xs={12} md={6}>
                {/* <TitleH3>
                    {i18n.t('pages.multipleDevice.deviceInfo')} <TitleSpan>{i18n.t('pages.multipleDevice.mandatory')}</TitleSpan>
                </TitleH3> */}
                <Select
                    formik={formik}
                    items={multipleDeviceTypes}
                    id="device-type"
                    title={i18n.t('pages.multipleDevice.deviceType')}
                    value={formik.values.deviceType}
                    onChange={(event) => {
                        formik.setFieldValue('deviceType', event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.deviceType && Boolean(formik.errors.deviceType)}
                />
                <Select
                    items={cnpjs}
                    id="cnpj"
                    title={i18n.t('common.cnpj')}
                    value={formik.values.cnpj}
                    onChange={(event) => formik.setFieldValue('cnpj', event.target.value)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.cnpj && Boolean(formik.errors.cnpj)}
                    disabled={isLoadingLocationsAndCnpjs}
                />
                <Select
                    items={timeZones}
                    id="fuso-horario"
                    enableSearch
                    title={i18n.t('pages.multipleDevice.timezone')}
                    value={formik.values.timezone}
                    onChange={(event) => formik.setFieldValue('timezone', event.target.value)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.timezone && Boolean(formik.errors.timezone)}
                />
            </Grid>

            <div style={checkboxStyle}>
                <Switch
                    label={i18n.t('pages.multipleDevice.expirationDate')}
                    checked={formik.values.expirationDate}
                    onChange={(event) => formik.setFieldValue('expirationDate', event.target.checked)}
                />
                <InfoTooltip tooltip={i18n.t('pages.multipleDevice.expirationDateDescription')} />
            </div>
            {formik.values.expirationDate && (
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'start' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            sx={{
                                marginLeft: '16px !important',
                                width: 'calc(100% - 32px)',
                                fontSize: 12,
                                fontFamily: 'Open Sans',
                                '& .MuiInputBase-root': {
                                    flexDirection: 'row-reverse',
                                },
                                '& .MuiButtonBase-root': {
                                    color: '#2D9CDB',
                                },
                            }}
                            slotProps={{ textField: { placeholder: i18n.t('filter.from') } }}
                            value={formik.values.startPeriod}
                            onChange={(val) => formik.setFieldValue('startPeriod', val)}
                        />

                        <DatePicker
                            format="DD/MM/YYYY"
                            sx={{
                                marginLeft: '16px !important',
                                width: 'calc(100% - 32px)',
                                fontSize: 12,
                                fontFamily: 'Open Sans',
                                '& .MuiInputBase-root': {
                                    flexDirection: 'row-reverse',
                                },
                                '& .MuiButtonBase-root': {
                                    color: '#2D9CDB',
                                },
                            }}
                            slotProps={{ textField: { placeholder: i18n.t('filter.to') } }}
                            value={formik.values.endPeriod}
                            onChange={(val) => formik.setFieldValue('endPeriod', val)}
                        />
                    </LocalizationProvider>
                </div>
            )}
        </MultipleDeviceDivider>
    );
} 